import { clone, cloneDeep } from 'lodash';
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type {
  IAppPermissionDomain} from './../../../../libs/types/src/lib/types';
import {
  IFeigCustomer
} from './../../../../libs/types/src/lib/types';
import axios from 'axios';
import { sortBy } from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
import {
  Action,
  Module,
  Mutation,
  MutationAction,
  VuexModule,
} from 'vuex-module-decorators';
import type { ICustomer, IManagementUser } from '@license-manager/types';
import $http from '../services/api';
import type { FindManyOptions } from 'typeorm';

@Module({ namespaced: true, name: 'apppermission' })
export default class AppPermission extends VuexModule {
  isLoading = false;
  private _customerDomains: { [key: number]: IAppPermissionDomain[] } = {};

  get customerDomains() {
    return (id: number) => {
      return this._customerDomains[id];
    };
  }

  @Mutation
  setLoading(loadingState = false) {
    this.isLoading = loadingState;
  }

  @Mutation
  setCustomerDomains({
    customerId,
    customerDomains,
  }: {
    customerId: number;
    customerDomains: IAppPermissionDomain[];
  }) {
    this._customerDomains[customerId] = customerDomains;
  }


  @Action
  async loadCustomerDomains({ customerId }): Promise<IAppPermissionDomain[]> {
    if (!customerId) {
      return;
    }

    let domains: IAppPermissionDomain[] = [];
    this.context.commit('setLoading', true);
    try {
      domains = await $http
        .get('/app-permissions/domain/customer/' + customerId, {params: {loadTrees: true}})
        .then(({ data }) => data);
    } catch (e) {
      domains = [];
      console.error(e);
    }

    this.context.commit('setCustomerDomains', {
      customerId,
      customerDomains: domains,
    });
    this.context.commit('setLoading', false);
    return clone(domains);
  }
}
